export default __webpack_public_path__ + "static/air_curtain_w.60f545f654aa3bc2569ef0ddfe59a166.svg";